import React, { useState } from 'react';
import './Gallery.css';
import about_top_nav_2 from '../assets/about_top_nav_2.jpg';
import Logo from '../assets/PNG_Logo.png';
import {
  FaDraftingCompass,
  FaProjectDiagram,
  FaPlug,
  FaTools,
  FaHome,
  FaCouch
} from 'react-icons/fa';

// 🔧 Services
const services = [
  { icon: <FaDraftingCompass />, label: '2D Planning', sub: '& Details' },
  { icon: <FaProjectDiagram />, label: 'Structural', sub: 'Drawings' },
  { icon: <FaPlug />, label: 'Electrical', sub: 'Drawings' },
  { icon: <FaTools />, label: 'Mechanical', sub: '& Plumbing' },
  { icon: <FaHome />, label: 'Exterior design', sub: '& Visualisation' },
  { icon: <FaCouch />, label: 'Interior design', sub: '& Visualisation' },
];

// 🔧 Categories
const categories = [
  { key: 'ALL', label: 'ALL' },
  { key: 'planning', label: 'PLANNING' },
  { key: 'structural', label: 'STRUCTURAL DRAWING' },
  { key: 'elevation', label: '3D ELEVATION DRAWINGS' },
  { key: 'electrical', label: 'ELECTRICAL DRAWING' },
  { key: 'interior', label: 'INTERIOR DESIGNS' },
  { key: 'mep', label: 'MEP DRAWING' },
  { key: 'youtube', label: 'YOUTUBE VIDEOS' },
];

// 🖼️ Image Media (Add type: 'image')
const imageMedia = [
  // 🟦 Planning
  { src: '/gallery/planning/Planning_1.jpg', category: 'planning', type: 'image' },
  { src: '/gallery/planning/Planning_2.jpg', category: 'planning', type: 'image' },
  { src: '/gallery/planning/Planning_3.jpg', category: 'planning', type: 'image' },
  { src: '/gallery/planning/Planning_4.jpg', category: 'planning', type: 'image' },
  { src: '/gallery/planning/Planning_5.jpg', category: 'planning', type: 'image' },

  // 🟥 Structural
  { src: '/gallery/structural/Structural_1.jpg', category: 'structural', type: 'image' },
  { src: '/gallery/structural/Structural_2.png', category: 'structural', type: 'image' },
  { src: '/gallery/structural/Structural_3.jpg', category: 'structural', type: 'image' },
  { src: '/gallery/structural/Structural_4.jpg', category: 'structural', type: 'image' },
  { src: '/gallery/structural/Structural_5.jpg', category: 'structural', type: 'image' },

  // 🟩 Electrical
  { src: '/gallery/electrical/Electrical_1.jpg', category: 'electrical', type: 'image' },
  { src: '/gallery/electrical/Electrical_2.jpg', category: 'electrical', type: 'image' },
  { src: '/gallery/electrical/Electrical_3.jpg', category: 'electrical', type: 'image' },
  { src: '/gallery/electrical/Electrical_4.jpg', category: 'electrical', type: 'image' },
  { src: '/gallery/electrical/Electrical_5.jpg', category: 'electrical', type: 'image' },

  // 🟨 Interior
  { src: '/gallery/interior/Interior_1.jpg', category: 'interior', type: 'image' },
  { src: '/gallery/interior/Interior_2.jpg', category: 'interior', type: 'image' },
  { src: '/gallery/interior/Interior_3.jpg', category: 'interior', type: 'image' },
  { src: '/gallery/interior/Interior_4.jpg', category: 'interior', type: 'image' },
  { src: '/gallery/interior/Interior_5.jpg', category: 'interior', type: 'image' },

  // 🟧 3D Elevation
  { src: '/gallery/3D_Elevation_Drawings/3D_Elevation_1.jpg', category: 'elevation', type: 'image' },
  { src: '/gallery/3D_Elevation_Drawings/3D_Elevation_2.jpg', category: 'elevation', type: 'image' },
  { src: '/gallery/3D_Elevation_Drawings/3D_Elevation_3.jpg', category: 'elevation', type: 'image' },
  { src: '/gallery/3D_Elevation_Drawings/3D_Elevation_4.jpg', category: 'elevation', type: 'image' },
  { src: '/gallery/3D_Elevation_Drawings/3D_Elevation_5.jpg', category: 'elevation', type: 'image' },

  // 🟪 MEP
  { src: '/gallery/mep/mep_1.jpg', category: 'mep', type: 'image' },
  { src: '/gallery/mep/mep_2.jpg', category: 'mep', type: 'image' },
  { src: '/gallery/mep/mep_3.jpg', category: 'mep', type: 'image' },
  { src: '/gallery/mep/mep_4.jpg', category: 'mep', type: 'image' },
  { src: '/gallery/mep/mep_5.jpg', category: 'mep', type: 'image' },
];


// 📹 YouTube Videos
const videoMedia = [
  { type: 'video', videoId: 'fT8e6OmAaGA', category: 'youtube' },
  { type: 'video', videoId: 'HuJTIAHb-IQ', category: 'youtube' },
  { type: 'video', videoId: 'Ka4X9wvFsLk', category: 'youtube' },
];

// 📦 All Media Combined
const allMedia = [...imageMedia, ...videoMedia];

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('ALL');

  const filteredMedia =
    selectedCategory === 'ALL'
      ? allMedia
      : allMedia.filter(media => media.category === selectedCategory);

  return (
    <div className="Galletry_container">
    

   <div className="Galletry_container">
  <div className="gallery-container">
    <h2 className="nandanam-title">Nandanam Infra Project Gallery</h2>

    {/* Filter Buttons */}
    <div className="gallery-nav">
      {categories.map(cat => (
        <button
          key={cat.key}
          className={`gallery-btn ${selectedCategory === cat.key ? 'active' : ''}`}
          onClick={() => setSelectedCategory(cat.key)}
        >
          {cat.label}
        </button>
      ))}
    </div>

    {/* Media Grid */}
    <div className="gallery-grid">
      {filteredMedia.map((media, index) => (
        <div className="gallery-card" key={index}>
          {media.type === 'image' ? (
            <img src={media.src} alt={`img-${index}`} loading="lazy" />
          ) : (
            <div className="video-wrapper">
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${media.videoId}`}
                title={`YouTube Video ${index}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
</div>

    </div>
  );
};

export default Gallery;
